function ScrollIntoView(elementId, attempt) {
  setTimeout(() => {
    const element = document.getElementById(elementId);

    if (element) {
      const yOffset = 90;
      const scrollToY = element.offsetTop - yOffset;
      if (element.closest) {
        window.scrollTo({ top: scrollToY, behavior: 'smooth' });
      } else {
        let y = window.pageYOffset || window.screenTop || 0;
        const direction = y < scrollToY ? 1 : -1;

        const smoothScroll = () => setTimeout(() => {
          y += 40 * direction;
          y = direction === 1 ? Math.min(y, scrollToY) : Math.max(y, scrollToY);
          window.scrollTo(0, y);
          if ((direction === 1 && y < scrollToY) || (direction === -1 && y > scrollToY)) {
            smoothScroll();
          }
        }, 30);

        smoothScroll();
      }
    } else {
      const nextAttempt = (attempt || 0) + 1;
      if (nextAttempt < 5) {
        setTimeout(() => ScrollIntoView(elementId, nextAttempt), 100);
      }
    }
  }, 100);
}

export default ScrollIntoView;
